module.exports = __webpack_public_path__ + "img/forum-events-192.17783506.png";